/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseResult } from './ResponseResult';
import {
    ResponseResultFromJSON,
    ResponseResultFromJSONTyped,
    ResponseResultToJSON,
    ResponseResultToJSONTyped,
} from './ResponseResult';
import type { ShipExpecteds } from './ShipExpecteds';
import {
    ShipExpectedsFromJSON,
    ShipExpectedsFromJSONTyped,
    ShipExpectedsToJSON,
    ShipExpectedsToJSONTyped,
} from './ShipExpecteds';

/**
 * 
 * @export
 * @interface ResponseShipExpected
 */
export interface ResponseShipExpected {
    /**
     * 
     * @type {ResponseResult}
     * @memberof ResponseShipExpected
     */
    result: ResponseResult;
    /**
     * 
     * @type {ShipExpecteds}
     * @memberof ResponseShipExpected
     */
    data: ShipExpecteds;
}

/**
 * Check if a given object implements the ResponseShipExpected interface.
 */
export function instanceOfResponseShipExpected(value: object): value is ResponseShipExpected {
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ResponseShipExpectedFromJSON(json: any): ResponseShipExpected {
    return ResponseShipExpectedFromJSONTyped(json, false);
}

export function ResponseShipExpectedFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseShipExpected {
    if (json == null) {
        return json;
    }
    return {
        
        'result': ResponseResultFromJSON(json['result']),
        'data': ShipExpectedsFromJSON(json['data']),
    };
}

export function ResponseShipExpectedToJSON(json: any): ResponseShipExpected {
    return ResponseShipExpectedToJSONTyped(json, false);
}

export function ResponseShipExpectedToJSONTyped(value?: ResponseShipExpected | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': ResponseResultToJSON(value['result']),
        'data': ShipExpectedsToJSON(value['data']),
    };
}

